import React, { ChangeEvent, useEffect, useState } from "react";
import "./App.scss";
import { Diagram } from "./components/diagram/Diagram";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Success } from "./components/Payment/Success/Success";
import { useAppDispatch, useAppSelector } from "./redux-store/store";
import { authThunk, logOutThunk } from "./redux-store/registration-login-auth";
import { getTariffs } from "./redux-store/tariffs-reducer";
import { ForgotPassword } from "./components/Forgot/ForgotPassword";
import { ResetPassword } from "./components/ResetPassword";
import { Pay } from "./components/Payment/Pay/Pay";
import "@fontsource/bebas-neue";
import "@fontsource/pacifico";
import { HashLink as Anchor } from "react-router-hash-link";
import { Osnova } from "./components/Osnova";
import { CircularProgress } from "@mui/material";
import { ErrorSnackbar } from "./feature/ErorSnackBar";
import { Footer } from "./components/Footer/Footer";
import { Welcome } from "./components/Welcome/Welcome";
import LoginIcon from "@mui/icons-material/Login";
import { Profile } from "./components/Profile/Profile";
import { SnackBarSuccess } from "./feature/SnackBarSuccess";
import { Error } from "./components/Payment/Error/Error";
import { DiagramCompatibility } from "./components/diagram/DiagramCompatibility";
import { PlusSupport } from "./feature/PlusSupport";
import { SuccessDateOnce } from "./components/Payment/Success/SuccessDateOnce";
import { SuccessLesson } from "./components/Payment/Success/SuccessLesson";
import { LearnPay } from "./components/LearnPay";
import { AdminTable } from "./Admin/component/AdminTable";
import { UserInfo } from "./Admin/component/UserInfo";
import { BlogAll } from "./components/Blog/BlogAll";
import { Blog } from "./components/Blog/Blog";
import { Konf } from "./components/OfertaKonf/Konf";
import { Oferta } from "./components/OfertaKonf/Oferta";
import { NotFound } from "./components/NotFound/NotFound";
import logotip from "./logo-icon.png";
import menuBurger from "./burger-menu.png";
import { PayLand } from "./components/Payment/Pay/PayLand";
import { SuccessLand } from "./components/Payment/Success/SuccessLand";
import RedirectToNonWWW from "./RedirectToNonWWW";
import AppLand from "./AppLand";

function App() {
  const loc = useLocation();
  const dispatch = useAppDispatch();
  const [check, setCheck] = useState(false);
  const auth = useAppSelector((state) => state.registrationReducer.auth);
  const admin = useAppSelector((state) => state.registrationReducer.admin);
  const initialize = useAppSelector((state) => state.errorReducer.initialize);
  const fromPage = loc.state?.pathname || "/";
  useEffect(() => {
    dispatch(authThunk());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getTariffs());
  }, [dispatch]);
  useEffect(() => {
    localStorage.setItem("path", loc.pathname);
    window.scrollTo(0, 0);
  }, [loc.pathname]);

  const onClickOut = () => {
    dispatch(logOutThunk());
    setCheck(false);
  };

  if (!initialize) {
    return (
      <div
        style={{
          position: "fixed",
          top: "30%",
          textAlign: "center",
          width: "100%"
        }}
      >
        <CircularProgress style={{ color: "white" }} />
      </div>
    );
  }

  if (initialize && fromPage !== "/" && auth) {
    return <Navigate to={fromPage} replace />;
  }
  const checkBurgerFunc = (e: ChangeEvent<HTMLInputElement>) => {
    setCheck(e.currentTarget.checked);
  };

  const closeBurger = () => {
    setCheck(false);
  };
  if (loc.pathname === "/priemihovamatrix") {
    return <AppLand fi={"Мария Приемыхова"} tgName={"@mariymani"}
                    tg={"https://t.me/mariymani"}
                    youTube={"https://t.me/mariymani"}
                    tgUznat={'https://t.me/mariymani'}
                    vk={"https://vk.com/club207456675"}
                    whats={"https://t.me/mariymani"} about={'Дипломированный педагог и эксперт по нумерологии метода Матрица судьбы. Помогла уже более 1500 ученикам рассчитать свою собственную матрицу судьбы и разобраться в анализе своей Матрицы . Готова помочь и вам!'} />;

  }
  if (loc.pathname === "/zolotkomatrix") {
    return <AppLand fi={"Анна Золотько"} tgName={"@zolotkoanna4"}
                    tg={"https://t.me/zolotkoanna4"}
                    tgUznat={'https://t.me/zolotkoanna4'}
                    vk={"https://vk.com/id613241088"}
                    about={'Дипломированный педагог-психолог и эксперт по нумерологии метода Матрица души. Помогла разобрать свои матрицы более 100 клиентам. Готова помочь и Вам!'} />;

  }
  if (loc.pathname === "/godynovamatrix") {
    return <AppLand fi={"Наталья Годунова"} tgName={"@natalia_numerologMS"}
                    tgUznat={'https://t.me/natalia_numerologMS'}
                    tg={"https://t.me/numerologGodunova"}
                    vk={"https://vk.com/numerolog_godunowa"}
                    about={'Эксперт по нумерологии метода Матрицы судьбы с образованием психолога. С помощью анализа Матрицы судьбы я изменила свою жизнь к лучшему и помогла более 150 клиентам. Помогу и вам!'} />;

  }

  if (loc.pathname === "/suzevamatrix") {
    return <AppLand fi={"Маргарита Сюзева"} tgName={"@provodnik_Margarita"}
                    tgUznat={'https://t.me/provodnik_Margarita'}
                    tg={"https://t.me/vedma_rita"}
                    vk={"https://vk.com/provodnik_margarita"}
                    about={'Бизнес психолог, педагог, нумеролог и эксперт метода матрица судьбы. Читая по цифрам разложу твою жизнь по буквам и вдохновлю на реализацию целей.'} />;

  }

  if (loc.pathname === "/tokarevamatrix") {
    return <AppLand fi={"Токарева Ольга"} tgName={"@olanymerolog"}
                    tgUznat={'https://t.me/olanymerolog'}
                    tg={"https://t.me/kluchiki_k_sebe"}
                    vk={"https://vk.com/id118355827"}
                    youTube={"https://youtube.com/@olanymerolog?si=k_6HY_f6UrT4XJaO"}
                    about={'Наследственный нумеролог.Дипломированный специалист по методу Матрица судьбы.Многолетняя практика в работе с датой рождения, Таро, игро-практиках и отливках воском.Веду проект по трансформации личности Переход'} />;

  }
  if (loc.pathname === "/schastlivayamatrix") {
    return <AppLand fi={"Счастливая Настасья"} tgName={"@StasyHappy"}
                    tgUznat={'https://t.me/StasyHappy'}
                    tg={"https://t.me/numerologHappy"}
                    vk={"https://vk.com/schastlivaya2005"}
                    about={'Сертифицированный нумеролог. Знаю, где у тебя "звездный потенциал", а где кармический тормоз. Считаю чужие матрицы, как кто то считает калории-быстро и метко.'} />;

  }
  if (loc.pathname === "/baskakovamatrix") {
    return <AppLand fi={"Баскакова Ольга"} tgName={"@oh_esquirol"}
                    tgUznat={'https://t.me/oh_esquirol'}
                    tg={"https://t.me/t0wards_myself"}
                    about={'Дипломированный специалист по нумерологии метода Матрица Судьбы. Твоя судьба уже говорит с тобой через числа. Я помогу тебе её услышать.'} />;

  }
  if (loc.pathname === "/tkachevamatrix") {
    return <AppLand fi={"Ткачева Яна"} tgName={"@yana_tkacheva"}
                    tgUznat={'https://t.me/yana_tkacheva'}
                    tg={"https://t.me/+ShqA0uzy4x8wODcy"}
                    about={'Инструктор по методу Матрица Души. Этот метод дает глубокий смысл понимания жизни, поэтому его выбирают клиенты и ученики.'} />;

  }



  if (loc.pathname === "/ivanchihinamatrix") {
    return <AppLand fi={"Иванчихина Екатерина"} tgName={"@katrine_wise"}
                    tgUznat={'https://t.me/katrine_wise'}
                    tg={"https://t.me/katrine_wise"}
                    inst={'https://www.instagram.com/katrine_wise?igsh=dng4YWZtdm9hZjEz&utm_source=qr'}
                    about={'Приветствую ❤️ Меня зовут Екатерина Иванчихина, я - нумеролог, помогаю людям легко прийти к своим целям с помощью Матрицы Судьбы. И хочу познакомить вас с инструментом, который поможет по-настоящему изменить вашу жизнь.'} />;

  }
  if (loc.pathname === "/lavrinovichmatrix") {
    return <AppLand fi={"Лавринович Екатерина"} tgName={"@katerina_lawrinovich"}
                    inst={'https://www.instagram.com/katerina_lawrinovich?igsh=MXhsZDg5bWE0anNsMw=='}
                    tiktok={'www.tiktok.com/@katerina_lawrinovich'}
                    tgUznat={'https://t.me/katerina_lawrinovich'}
                    tg={"https://t.me/+a4mGMqR6W5c2ZWY6"}
                    about={'Дипломированный эксперт по нумерологии метода Матрица судьбы. Бережно и уверенно приведу к лучшей жизни. Консультации онлайн. Персональная матрица. Совместимость партнеров. Детская матрица. Эксперт по работе с метафорическими картами. Расстановщик.'} />;

  }
  if (loc.pathname === "/ionenkovamatrix") {
    return <AppLand fi={"Ирина Ионенкова"} tgName={"@Ionenkova_irina"}
                    tgUznat={'https://t.me/Ionenkova_irina'}
                    whats={'https://api.whatsapp.com/send/?phone=79274547575&text=Доброго+времени+суток%2C+меня+заинтересовала...&type=phone_number&app_absent=0'}
                    tg={"https://t.me/irina_ionenkova"}
                    vk={'https://vk.com/irina_ionenkova'}
                    about={'Более 6 лет  сертифицированный нумеролог, энергопрактик международной академии Access Consciousness и специалист по работе с мышлением'} />;

  }
  if (loc.pathname === "/perovskayamatrix") {
    return <AppLand fi={"Наталья Петровская"} tgName={"@natnumer"}
                    tgUznat={'https://t.me/natnumer'}
                    whats={'https://api.whatsapp.com/send/?phone=%2B79027606908&text&type=phone_number&app_absent=0'}
                    tg={"https://t.me/tvoyanumerologiyatut"}
                    vk={'https://vk.com/id81493843'}
                    about={'Специалист по нумерологии метода Матрица судьбы. Помогу найти себя в этом огромном мире. Проводник в ваши Хроники Акаши (библиотека знаний Вашей Души, прошлые воплощения, связь с Вашими наставниками, их ответы на проблемные вопросы и ситуации, которые повторяются в Вашей жизни вновь и вновь).'} />;

  }
  if (loc.pathname === "/alferovamatrix") {
    return <AppLand fi={"Наталья Алфёрова"} tgName={"@Natali_Matrix"}
                    tgUznat={'https://t.me/Natali_Matrix'}
                    tg={"https://t.me/+2SuswvuBLQhmZjBi"}
                    vk={'https://vk.com/jivanatali'}
                    about={'Эксперт по системе самопознания Матрица судьбы. Провела множество консультаций с положительными отзывами. Помогла клиентам понять себя и что с ними происходит. Помогла найти ответы на волнующие их вопросы. Готова помочь и тебе.'} />;

  }
  if (loc.pathname === "/kolosencevmatrix") {
    return <AppLand fi={"Анастасия Колосенцева"} tgName={"@anastasiakolosencev"}
                    tgUznat={'https://t.me/anastasiakolosencev'}
                    tg={"https://t.me/anastasiakolosencev"}
                    vk={'https://vk.com/id264080604'}
                    whats={'https://api.whatsapp.com/send?phone=79184409398'}
                    about={'Сертифицированный специалист с 3х-летним опытом в области нумерологии метода Матрица судьбы.Помогла более 1000 клиентам узнать о своих сильных и слабых сторонах, талантах и предназначении ,а так же прогноз на будущее. Запишитесь сейчас и получите ответы на все ваши вопросы!'} />;

  }
  if (loc.pathname === "/andreevamatrix") {
    return <AppLand fi={"Елена Андреева"} tgName={"@Elena_Andreeva777"}
                    tgUznat={'https://t.me/Elena_Andreeva777'}
                    tg={"https://t.me/Elena_Andreeva777"}
                    vk={'https://vk.com/helenaandreeva'}
                    whats={'https://wa.me/79231523710'}
                    about={'Сертифицированный специалист в области Нумерологии (Классической, Ангельской, Здоровья), также по методу «Матрица Судьбы» и Совместимости партнёров.\nБуду рада стать вашим проводником в этом удивительном мире Эзотерики и помочь познать себя на более глубоком уровне. \nОбращайтесь за разборами!'} />;

  }
  if (loc.pathname === "/dilmanmatrix") {
    return <AppLand fi={"Цицана Дильман"} tgName={"@TsiFeya_Cicana3993"}
                    tgUznat={'https://t.me/TsiFeya_Cicana3993'}
                    tg={"https://t.me/TsiFeya_Cicana3993"}
                    vk={'https://vk.com/ooxi1989'}
                    whats={'https://wa.me/79888883236'}
                    about={'Дипломированный специалист по нумерологий метода Матрица судьбы .Твоя душа уже говорит с тобой .Познай себя через числа .Я помогу раскрыть Тебе твою миссию на земле!'} />;

  }
  if (loc.pathname === "/karpenkomatrix") {
    return <AppLand fi={"Александра Карпенко"} tgName={"@Tayny_soznaniya5444"}
                    tgUznat={'https://t.me/Tayny_soznaniya5444'}
                    tg={"https://t.me/Yourtruedateofbirth"}
                    vk={'https://vk.com/dr.aleksandra_30'}
                    about={'Откройте для себя силу цифровой психологии и нумерологии! ??? Узнайте, как числа могут раскрыть ваши скрытые таланты, предсказать важные события и помочь принять верные решения.'} />;

  }
  if (loc.pathname === "/starchenkomatrix") {
    return <AppLand fi={"Светлана Старченко"} tgName={"@StarLana1113"}
                    tgUznat={'https://t.me/StarLana1113'}
                    tg={"https://t.me/astrovedlana"}
                    vk={'https://vk.com/id120312917'}
                    about={'Дипломированный астропсихолог и нумеролог. Готова помочь Вам в разборе и анализе матрицы судьбы'} />;

  }
  if (loc.pathname === "/ermakowamatrix") {
    return <AppLand fi={"Ольга Ермакова"} tgName={"@olga02081984"}
                    tgUznat={'https://t.me/olga02081984'}
                    tg={'https://t.me/izhaosavporaydok'}
                    about={'Помогу увидеть закономерности в событиях вашей жизни и найти ответ на главный вопрос: Для чего это происходит?'} />;

  }
  if (loc.pathname === "/ivanovamatrix") {
    return <AppLand fi={"Виктория Иванова"} tgName={"@tg_ivanovaa"}
                    tgUznat={'https://t.me/tg_ivanovaa'}
                    tg={"https://t.me/vika_ivanova_tg"}
                    about={'LOVE коуч | семейный психолог | эксперт по методу Матрица Судьбы. Открою доступ к твоей женской силе, деньгам и отношениям всего за 1 консультацию.'} />;

  }
  if (loc.pathname === "/aleksandrovamatrix") {
    return <AppLand fi={"Анна Александрова"} tgName={"@anna_soulmatrix"}
                    tgUznat={'https://max.ru/u/f9LHodD0cOJWFUjjvQzXXxaKxrVFTtn6_1ibsq75Fq9FE5uLq1dqBVVKZCQ'}
                    tg={"https://t.me/Anna_tvoi_tarolog"}
                    vk={'https://vk.ru/aleksaanna'}
                    about={'Дипломированный таролог , эксперт по нумерологии метода Матрица судьбы . Готова помочь вам рассчитать свою собственную матрицу и разобраться какие энергии даны вам по факту рождения.Как зная это обрести любовь, деньги ,и найти гармонию,'} />;

  }
  if (loc.pathname === "/dvorcovamatrix") {
    return <AppLand fi={"Ксения Дворцова"} tgName={"@Kseni15"}
                    tgUznat={'https://t.me/Kseni15'}
                    tg={"https://t.me/Kseni15"}
                    vk={'https://vk.ru/vedana6974'}
                    about={'Ведана, Ксения Дворцова — психолог и нумеролог с 15-летним стажем. Помогает через дату рождения увидеть корень повторяющихся проблем в деньгах, любви и здоровье, чтобы выйти на новый уровень жизни.'} />;

  }

  return (
    <>
      <RedirectToNonWWW />
      <div className={"App"}>
        {/*<img width={300} src={''} alt="" />*/}
        {/*<div className={'errorTechnik'}>На сайте ведутся техниеские работы</div>*/}
        <PlusSupport />
        {loc.pathname === "/welcome" ? undefined : (
          <div className={"header"}>
            <Link onClick={closeBurger} to={"/"}>
              <img src={logotip as string} alt="Логотип" />
            </Link>
            <div className={`headerList ${check ? "activeBurger" : ""}`}>
              <div className={"divOpacity"}></div>
              <div className={"miniHeaderList"}>
                <Anchor
                  onClick={closeBurger}
                  smooth
                  to={"/#sectionDateScroll"}
                  className={"menuSpan"}
                >
                  Калькулятор
                </Anchor>
                <Anchor
                  onClick={closeBurger}
                  smooth
                  to={"/#methodScroll"}
                  className={"menuSpan"}
                >
                  О методе
                </Anchor>
                <Link
                  onClick={closeBurger}
                  className={"menuSpan"}
                  to={"/blog"}
                >
                  Блог
                </Link>
                <a
                  onClick={closeBurger}
                  className={"menuSpan"}
                  href={"https://max.ru/id350704599422_bot?start=01xol6y7"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ИИ бот Личный нумеролог
                </a>
                <Link
                  onClick={closeBurger}
                  className={"menuSpan"}
                  to={"/learn"}
                >
                  Обучение
                </Link>
                <Anchor
                  onClick={closeBurger}
                  smooth
                  to={"/#tarif"}
                  className={"menuSpan"}
                >
                  Тарифы
                </Anchor>
                {admin ? (
                  <Link
                    onClick={closeBurger}
                    style={{ marginRight: 20, fontSize: 16 }}
                    className={"menuSpan"}
                    to={"/admin-table"}
                  >
                    Админ
                  </Link>
                ) : undefined}
                {auth ? <>
                  <div className={"divLine"}></div>
                  <Link
                    onClick={closeBurger}
                    className={"menuSpan noneKomp"}
                    to={"/profile/tarif"}
                  >
                    Мой тариф
                  </Link>
                  <Link
                    onClick={closeBurger}
                    className={"menuSpan noneKomp"}
                    to={"/profile/mymatrix"}
                  >
                    История поиска матриц
                  </Link>
                  <Link
                    onClick={closeBurger}
                    className={"menuSpan noneKomp"}
                    to={"/profile/orders"}
                  >
                    История заказов
                  </Link>
                  <a
                    onClick={closeBurger}
                    className={"menuSpan noneKomp"}
                    href={"https://max.ru/id350704599422_bot?start=01xol6y7"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ИИ бот Личный нумеролог
                  </a>
                  <Link
                    onClick={closeBurger}
                    className={"menuSpan noneKomp"}
                    to={"/profile/learn"}
                  >
                    Видео-Обучение
                  </Link>
                  <Link
                    onClick={closeBurger}
                    className={"menuSpan noneKomp"}
                    to={"/profile/support"}
                  >
                    Написать в поддержку
                  </Link>
                  <span className={"menuSpan outClass"}
                        onClick={onClickOut}>Выйти из аккаунта
                </span>
                </> : undefined}
              </div>
            </div>
            {auth ? (
              <>
                <div className={"divLog"}>
                  <Link
                    onClick={closeBurger}
                    style={{ fontSize: 16 }}
                    className={"batonStandart"}
                    to={"/profile/user"}
                  >
                    Профиль
                  </Link>
                  <input
                    onChange={checkBurgerFunc}
                    checked={check}
                    type="checkbox"
                    id="toggle-menu"
                  />
                  <label htmlFor="toggle-menu" className="burger-icon">
                    <img src={menuBurger as string} alt="" />
                  </label>
                </div>
              </>
            ) : (
              <>
                <div className={"divLog"}>
                  <Link
                    style={{ marginRight: 20 }}
                    className={"batonStandart"}
                    to={"/welcome"}
                  >
                    Войти <LoginIcon />
                  </Link>
                  <input
                    onChange={checkBurgerFunc}
                    checked={check}
                    type="checkbox"
                    id="toggle-menu"
                  />
                  <label htmlFor="toggle-menu" className="burger-icon">
                    <img src={menuBurger as string} alt="" />
                  </label>
                </div>
              </>
            )}
          </div>

        )}
        <Routes>
          <Route path={"/"} element={<Osnova />} />
          <Route path={"/matrix"} element={<Diagram />} />
          <Route
            path={"/matrixcompatibility"}
            element={<DiagramCompatibility />}
          />
          <Route path={"/success"} element={<Success />} />
          <Route path={"/success-land"} element={<SuccessLand />} />
          <Route path={"/learn"} element={<LearnPay />} />
          <Route path={"/success-date-once"} element={<SuccessDateOnce />} />
          <Route path={"/success-lesson"} element={<SuccessLesson />} />
          <Route path={"/error"} element={<Error />} />
          <Route path={"/welcome"} element={<Welcome />} />
          <Route path={"/forgot"} element={<ForgotPassword />} />
          <Route path={"/reset-password/:token"} element={<ResetPassword />} />
          <Route path={"/pay"} element={<Pay />} />
          <Route path={"/payland"} element={<PayLand />} />
          <Route path={"/profile/*"} element={<Profile />} />
          <Route path="/blogs" element={<BlogAll />} />
          <Route path="/blog/:id" element={<Blog />} />
          <Route path={"/blog"} element={<BlogAll />} />
          <Route path={"/konf"} element={<Konf />} />
          <Route path={"/oferta"} element={<Oferta />} />
          <Route path={"/admin-table"} element={<AdminTable />} />
          <Route path={"/admin-table/:id"} element={<UserInfo />} />
          <Route path={"/not-found"} element={<NotFound />} />
          <Route path={"/priemihovamatrix"} element={<AppLand />} />
          <Route path={"/zolotkomatrix"} element={<AppLand />} />
          <Route path={"/godynovamatrix"} element={<AppLand />} />
          <Route path={"/suzevamatrix"} element={<AppLand />} />
          <Route path={"/tokarevamatrix"} element={<AppLand />} />
          <Route path={"/schastlivayamatrix"} element={<AppLand />} />
          <Route path={"/baskakovamatrix"} element={<AppLand />} />
          <Route path={"/tkachevamatrix"} element={<AppLand />} />
          <Route path={"/ivanchihinamatrix"} element={<AppLand />} />
          <Route path={"/lavrinovichmatrix"} element={<AppLand />} />
          <Route path={"/ionenkovamatrix"} element={<AppLand />} />
          <Route path={"/perovskayamatrix"} element={<AppLand />} />
          <Route path={"/alferovamatrix"} element={<AppLand />} />
          <Route path={"/kolosencevmatrix"} element={<AppLand />} />
          <Route path={"/andreevamatrix"} element={<AppLand />} />
          <Route path={"/dilmanmatrix"} element={<AppLand />} />
          <Route path={"/karpenkomatrix"} element={<AppLand />} />
          <Route path={"/starchenkomatrix"} element={<AppLand />} />
          <Route path={"/ermakowamatrix"} element={<AppLand />} />
          <Route path={"/ivanovamatrix"} element={<AppLand />} />
          <Route path={"/aleksandrovamatrix"} element={<AppLand />} />
          <Route path={"/dvorcovamatrix"} element={<AppLand />} />
          <Route path={"*"} element={<Navigate to="/not-found" />} />
        </Routes>
        <ErrorSnackbar />
        <SnackBarSuccess />
        {loc.pathname === "/welcome" ? undefined : <Footer />}
      </div>
    </>);
}

export default App;
